import React, { Fragment, useState, useEffect } from 'react';
import { Form, Input, Select, Button, Tooltip, Space, Flex } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { 
  PiGlobeDuotone, 
  PiFacebookLogoDuotone, 
  PiInstagramLogoDuotone, 
  PiLinkedinLogoDuotone, 
  PiTwitterLogoDuotone, 
  PiYoutubeLogoDuotone, 
  PiPinterestLogoDuotone, 
  PiSkypeLogoDuotone, 
  PiWhatsappLogoDuotone, 
  PiTelegramLogoDuotone,
  PiLinkDuotone
} from 'react-icons/pi';

const WebPages = ({ 
  name = "web_pages",
  initialValues = null,
  onChange = null,
  showAsFormList = true 
}) => {
  const [fieldValues, setFieldValues] = useState({});
  const form = Form.useFormInstance();

  // Ensure form is properly initialized with default values
  useEffect(() => {
    const currentValues = form.getFieldValue(name);
    if (!currentValues || !Array.isArray(currentValues) || currentValues.length === 0) {
      const defaultValues = getInitialValue();
      form.setFieldsValue({
        [name]: defaultValues
      });
    }
  }, [name, form, initialValues]);

  const pageDefaultTags = [
    { value: 'Website', icon: <PiGlobeDuotone className="me-2" /> },
    { value: 'Facebook', icon: <PiFacebookLogoDuotone className="me-2" /> },
    { value: 'Instagram', icon: <PiInstagramLogoDuotone className="me-2" /> },
    { value: 'LinkedIn', icon: <PiLinkedinLogoDuotone className="me-2" /> },
    { value: 'Twitter', icon: <PiTwitterLogoDuotone className="me-2" /> },
    { value: 'YouTube', icon: <PiYoutubeLogoDuotone className="me-2" /> },
    { value: 'Pinterest', icon: <PiPinterestLogoDuotone className="me-2" /> },
    { value: 'Skype', icon: <PiSkypeLogoDuotone className="me-2" /> },
    { value: 'WhatsApp', icon: <PiWhatsappLogoDuotone className="me-2" /> },
    { value: 'Telegram', icon: <PiTelegramLogoDuotone className="me-2" /> },
    { value: 'Other', icon: <PiLinkDuotone className="me-2" /> }
  ];

  const handleTagChange = (fieldKey, value) => {
    setFieldValues(prev => ({
      ...prev,
      [fieldKey]: value
    }));
  };

  const getInitialValue = () => {
    if (initialValues && Array.isArray(initialValues) && initialValues.length > 0) {
      return initialValues;
    }
    return [{ tag: 'Website', name: '', url: '' }];
  };

  if (!showAsFormList && onChange) {
    return null;
  }

  return (
    <Form.List 
      name={name}
      initialValue={getInitialValue()}
    >
      {(fields, { add, remove }) => (
        <Fragment>
          {fields.map((field, index) => {
            const currentTag = fieldValues[field.key] || 'Website';
            
            return (
              <div key={`webpage-${field.key}-${index}`} className="mb-3">
                <Flex justify="space-between" className="mb-2">
                  <div></div>
                  <div className="">
                    {fields.length > 1 && (
                      <Tooltip title="Remove web page">
                        <Button
                          type="text"
                          danger
                          size="small"
                          icon={<DeleteOutlined />}
                          onClick={() => {
                            remove(field.name);
                            setFieldValues(prev => {
                              const newValues = { ...prev };
                              delete newValues[field.key];
                              return newValues;
                            });
                          }}
                        />
                      </Tooltip>
                    )}
                  </div>
                </Flex>
                
                <Space.Compact style={{ display: 'flex', width: '100%' }}>
                  <Form.Item
                    name={[field.name, 'tag']}
                    // rules={[{ required: true, message: 'Platform required' }]}
                    noStyle
                  >
                    <Select
                      placeholder="Platform"
                      style={{ width: 140 }}
                      onChange={(value) => handleTagChange(field.key, value)}
                      options={pageDefaultTags.map(item => ({
                        value: item.value,
                        label: <span>{item.icon}{item.value}</span>
                      }))}
                    />
                  </Form.Item>

                  <Form.Item
                    name={[field.name, 'name']}
                    // rules={[{ required: true, message: 'Page name required' }]}
                    noStyle
                  >
                    <Input
                      placeholder="Page name"
                      style={{ width: 120 }}
                    />
                  </Form.Item>

                  <Form.Item
                    name={[field.name, 'url']}
                    rules={[
                      // { required: true, message: 'URL required' },
                      { type: 'url', message: 'Please enter a valid URL' }
                    ]}
                    noStyle
                  >
                    <Input
                      placeholder="https://example.com"
                      style={{ flex: 1 }}
                    />
                  </Form.Item>
                </Space.Compact>
              </div>
            );
          })}

          <Form.Item>
            <Button
              type="link"
              size='small'
              onClick={() => add({ tag: 'Website', name: '', url: '' })}
              icon={<PlusOutlined />}
              className='px-0'
            >
              Add Web Page
            </Button>
          </Form.Item>
        </Fragment>
      )}
    </Form.List>
  );
};

export default WebPages;


